export default __webpack_public_path__ + "c1e4fb2bce85ce2f07be74a6d13dfbd9.png";